import React from "react";
import handleLabel from "../../utils/handleLabel";

export default ({id, label, isRequired, disableLabel}) => (
  !disableLabel && label ? (
    <label
      id={id ? `${id}Label` : undefined}
      htmlFor={id ? `${id}Input` : undefined}
      className="field-label"
    >
      {handleLabel({label, isRequired})}
    </label>
  ) : null
);
